import React, { useEffect, useState } from 'react';
import { RequestDataSetting, updateSettingChat } from 'api/chat/setting/update-setting';
import { useSubscription } from 'hooks/use-subscription.hook';

interface IMessageProps {
  self: RequestDataSetting;
}

function Message({ self }: IMessageProps) {
  const subscription = useSubscription();
  const [messageSetting, setMessageSetting] = useState({
    text_size: self.text_size,
    auto_delete_after: self.auto_delete_after,
    isCheckChangeContent: false,
  });

  const handleChangeSize = (e) => {
    setMessageSetting({ ...messageSetting, text_size: e.target.value, isCheckChangeContent: true });
  };
  const handleChangeTime = (e) => {
    setMessageSetting({ ...messageSetting, auto_delete_after: e.target.value, isCheckChangeContent: true });
  };

  useEffect(() => {
    if (!messageSetting.isCheckChangeContent) return;

    const updateSettingSub = updateSettingChat(self._id, messageSetting).subscribe();

    subscription.add(updateSettingSub);
  }, [messageSetting, subscription, self._id]);

  return (
    <div className='message'>
      <div className='tab-item'>
        <li className='list-group-item border-bottom h-d_flex'>
          Text size
          <span>
            <select
              className='custom-select select-number'
              defaultValue={messageSetting.text_size}
              onChange={handleChangeSize}
            >
              <option value='20'>20</option>
              <option value='30'>30</option>
              <option value='40'>40</option>
              <option value='50'>50</option>
            </select>
          </span>
        </li>
      </div>
      <div className='tab-item'>
        <li className='list-group-item'>
          Auto delete message affter
          <span>
            <select
              className='custom-select'
              defaultValue={messageSetting.auto_delete_after}
              onChange={handleChangeTime}
            >
              <option value='1 week'>1 week</option>
              <option value='1 month'>1 month</option>
              <option value='1 year'>1 year</option>
              <option value='Never'>Never</option>
            </select>
          </span>
        </li>
      </div>
    </div>
  );
}

export default Message;
